import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Grid,
  Card,
  CardMedia,
  Button,
} from "@mui/material";
import ReusableButton from "../Reusable/PrimaryButton/PrimaryButton";
import {
  generateCartoonImages,
  getModelName,
  uploadFile,
  getGeneratedImagesByEvent,
  getUploadedImages,
} from "../../services/apiService";
import VisibilityIcon from "@mui/icons-material/Visibility";
import './IdeaBoard.css';
import { showToast } from "../Toast/CommonToast";
import LoaderWithBackdrop from "../Loader/loader";
// webSocket
import { useImageWebSocket } from "../../context/CartoonWebSocket";
import { useCreditPoints } from '../../services/CreditPointsProvider';
import Popup from "../Popup/Popup";
import Masonry from "react-masonry-css";
import ViewModuleIcon from "@mui/icons-material/ViewModule";
import ViewQuiltIcon from "@mui/icons-material/ViewQuilt";
import UploadImageCard from "../Reusable/UploadImageCard";
import ErrorPopup from "../Popup/ErrorPopup/ErrorPopup";


interface PayLoadImages {
  userId: string;
  eventId: string | null;
  imageUrl: string | undefined;
  creditsPoints: number | undefined;
}
interface Image {
  id: string; 
  [key: string]: any;
}

interface ImageId {
  _id?: string;
  url?: string;
  inputData?: {
    prompt?: string;
    image_urls?: string[];
  };
  usedPrompt?: string; 
}


const CartoonUploader = () => {
  const [previews, setPreviews] = useState<any>([]);
  const [generateImage, setGenerateImage] = useState<any[]>([]);
  const [uploadExistingImages, setUploadExistingImages] = useState<any[]>([]);
  const [hoveredCard, setHoveredCard] = React.useState<number | null>(null);
  const userId = localStorage.getItem("userId") || "";
  const [modelIdDetails, setModelIdDetails] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [previewImage, setPreviewImage] = useState<any>("");
  const [modelOpen, setModelOpen] = useState(false);
  const ImageMediaType = "image";
  const [previewImageUrl, setPreviewImageUrl] = useState<string>("");
  const { fetchCreditPoints } = useCreditPoints();
  const [viewType, setViewType] = useState<'grid' | 'masonry'>('masonry');
  const [uploadedViewType, setUploadedViewType] = useState<'grid' | 'masonry'>('masonry');
  const fileInputRef = React.useRef<HTMLInputElement | null>(null);
  const [errorPopupOpen, setErrorPopupOpen] = useState({
    open: false,
    message: "",
  });
  
   const handleButtonClick = () => fileInputRef.current && fileInputRef.current.click();
   const [selectedImageId, setSelectedImageId] = React.useState<ImageId | null>(null);

   useEffect(()=>{
    if(selectedImageId){
      setPreviews(selectedImageId?.url || "");
    }
   }, [selectedImageId]);
  // webSocket updates
  const {cartoonImageUrl, cartoonGeneratedImage, reconnectWebSocket} = useImageWebSocket();

  // console.log("cartoonImageUrl", cartoonImageUrl, cartoonGeneratedImage, generateImage)
  React.useEffect(() => {
    if (cartoonImageUrl && (cartoonGeneratedImage && cartoonGeneratedImage.length > 0)) {
      setGenerateImage((prev) => {
        // Merge and deduplicate by _id or url
        const allImages = [...cartoonGeneratedImage, ...prev];
        const uniqueMap = new Map();
        allImages.forEach(img => {
          const key = img._id || img.url;
          if (!uniqueMap.has(key)) {
            uniqueMap.set(key, img);
          }
        });
        const uniqueImages = Array.from(uniqueMap.values());
        // Sort by createdAt if available, newest first
        return uniqueImages.sort((a, b) => {
          if (a.createdAt && b.createdAt) {
            return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();
          }
          return 0;
        });
      });
      fetchCreditPoints(userId);
    }
  }, [cartoonImageUrl, cartoonGeneratedImage, userId, fetchCreditPoints]);
 

  // mediaType=image api
  const mediaGenerateImages = async () => {
    try {
      const response = await getModelName(ImageMediaType);
      if (response && response.status === "success") {
        setModelIdDetails(response.data);
      } else {
        console.error("No data found in the response.");
      }
    } catch (error) {
      console.error("Error fetching images:", error);
    }
  };
  React.useEffect(() => {
    mediaGenerateImages();
  }, [previews]);

  const modelId =
    modelIdDetails?.length > 0
      ? modelIdDetails.find(
        (item: any) => item.eventName === "Cartoon Images"
      )?._id
      : "68146db837ac9f090a4ca50a";

  if (!modelId) {
    console.error(
      "modelId is null. Check if 'Cartoon Images' exists in modelIdDetails."
    );
  }
 localStorage.setItem("cartoonModelId", modelId || "");

  const generatedAllCartoonImages = React.useCallback(async () => {
    try {
      const response = await getGeneratedImagesByEvent(userId, modelId);
      if (response && Array.isArray(response)) {
        setGenerateImage(() => {
          // Merge and deduplicate by _id or url
          const allImages = Array.isArray(response) ? response : [];
          const uniqueMap = new Map();
          allImages.forEach(img => {
            const key = img._id || img.url;
            if (!uniqueMap.has(key)) {
              uniqueMap.set(key, img);
            }
          });
          const uniqueImages = Array.from(uniqueMap.values());
          // Sort by createdAt if available, newest first
          return uniqueImages.sort((a, b) => {
            if (a.createdAt && b.createdAt) {
              return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();
            }
            return 0;
          });
        });
      } else {
        console.error("Invalid response format or no data found.");
        setGenerateImage([]);
      }
    } catch (error) {
      console.error("Error fetching images:", error);
      setGenerateImage([]);
    }
  }, [userId, modelId]);

    React.useEffect(() => {
    generatedAllCartoonImages();
  }, [generatedAllCartoonImages]);

  const CreditRes = modelIdDetails && modelIdDetails.find((item: any) => item?.eventName === "Cartoon Images")?.creditPoints;

  const generateFetchImages = async () => {
    reconnectWebSocket(); //reconnect the websocket
    const payLoadImages: PayLoadImages = {
      userId: userId,
      eventId: modelId,
      imageUrl: previewImageUrl || draggedImage || selectedImageId?.url || "",
      creditsPoints: CreditRes,
    };
    setIsLoading(true);

    try {
      const response = await generateCartoonImages(payLoadImages);
      fetchCreditPoints(userId);
      if (response && (response.status === "success" || response.success === true)) {
        setPreviews([]);
        setDraggedImage(null);
        setIsLoading(false);
        setSelectedImageId(null);
        const imageObject = response?.data?.imageGenerationId?.[0];
        if (imageObject) {
          setGenerateImage((prev) => [imageObject, ...prev]);
        }
      } else {
        setIsLoading(false);
        // Show popup for any failure, 404, 403, or errcode (string or number)
        const is404 = response?.statusCode === 404 || response?.errcode === "CRD404"
        const is403 = response?.statusCode === 403 || response?.errcode === "CRD403";
        if ( is404 || is403 || response?.errcode) {
          setErrorPopupOpen({
            open: true,
            message: response?.message || "Failed to generate image.",
          });
        } else {
          showToast(response?.message || "Failed to generate image.", "error");
        }
      }
    } catch (error: any) {
      setIsLoading(false);
      showToast(error?.message || "Failed to generate image.", "error");
      setErrorPopupOpen({
        open: true,
        message: error?.message || "Failed to generate image.",
      });
      console.error("Error fetching images:", error);
    }
  };

  const [uploadFiles, setUploadFile] = useState<File | null>(null); // eslint-disable-line @typescript-eslint/no-unused-vars

  const handleUpload = React.useCallback(
    async (event: React.ChangeEvent<HTMLInputElement>) => {
      setIsLoading(true);
      const files = event.target.files;
      if (!files || files.length === 0) return; // ✅ Safe check

      const file = files[0];
      setUploadFile(file);
      const uploadedUrl = URL.createObjectURL(file);
      setPreviews([uploadedUrl]);

      const formData = new FormData();
      formData.append("files", files[0]);
      formData.append("userId", userId);
      formData.append("eventId", modelId);
      formData.append("isIdeaBoardImage", "true");

      try {
        const response = await uploadFile(formData);
        setIsLoading(false);
        if (response && response.status === "success") {
          const uploadedUrl = response?.data[0].url;
          setPreviews((prev: any) => [...prev, uploadedUrl]);
          showToast(response.message, "success");
          setPreviewImageUrl(uploadedUrl);
          setIsLoading(false);
        } else {
          setIsLoading(false);
          showToast(response.message, "error");
        }
      } catch (error: any) {
        setIsLoading(false);
        showToast(error.message, "error");
      }
    },
    [userId, modelId, setUploadFile]
  );
  
  // Auto-upload when selectedImageId?.url is present
  useEffect(() => {
    const uploadImageFromUrl = async () => {
      if (selectedImageId?.url) {
        try {
          const response = await fetch(selectedImageId.url);
          const blob = await response.blob();
          const urlParts = selectedImageId.url.split('.');
          const ext = urlParts.length > 1 ? urlParts[urlParts.length - 1].split('?')[0] : 'jpg';
          const fileName = `selectedImage.${ext}`;
          const fileFromUrl = new File([blob], fileName, { type: blob.type });
          // Create a synthetic event
          const syntheticEvent = {
            target: {
              files: [fileFromUrl]
            }
          } as unknown as React.ChangeEvent<HTMLInputElement>;
          handleUpload(syntheticEvent);
        } catch (error) {
          showToast('Failed to upload image from URL', 'error');
        }
      }
    };
    if (selectedImageId?.url) {
      uploadImageFromUrl();
    }
    // Only run when selectedImageId?.url changes
  }, [selectedImageId?.url, handleUpload]);
  


  const uploadedAllExistingImages = React.useCallback(async () => {
    try {
      const response: Image[] = await getUploadedImages(userId, modelId);
      if (response) {
        setUploadExistingImages((prev: Image[]) => {
          const existingIds = new Set(prev.map((img) => img.id || img.url));
          const uniqueNewImages = response.filter(
            (img) => !existingIds.has(img.id || img.url)
          );
          return [...uniqueNewImages, ...prev];
        });
      } else {
        console.error("No data found in the response.");
      }
    } catch (error) {
      console.error("Error uploading file:", error);
    }
  }, [userId, modelId]);

    React.useEffect(() => {
    uploadedAllExistingImages();
  }, [previews, uploadedAllExistingImages]);

  const handleMouseEnter = (index: number) => {
    setHoveredCard(index);
  };

  const handleMouseLeave = () => {
    setHoveredCard(null);
  };
 const handleClickOpen = (generatedImage: any) => {
  const inputImage = Array.isArray(generatedImage?.inputData?.image_urls) && generatedImage.inputData.image_urls.length > 0
    ? generatedImage.inputData.image_urls[0]
    : generatedImage?.inputData;
  const cartoonImage = generatedImage?.url
  setPreviewImage({ inputImage, cartoonImage });
  setModelOpen(true);
};
  const handleClose = () => {
    setModelOpen(false);
  };
   const [draggedImage, setDraggedImage] = useState<any>(null);

  const handleDragStart = (image: any) => {
    setDraggedImage(image);
  };

  // const handleDragOver = (event: React.DragEvent<HTMLDivElement>) => {
  //   event.preventDefault(); 
  // }

  // const handleDrop = (event: React.DragEvent<HTMLDivElement>) => {
  //   event.preventDefault();
  //   if (draggedImage) {
  //     setDraggedImage(null);
  //   }
  // };
  
  

  return (
    <Box>
      {isLoading && <LoaderWithBackdrop open={isLoading} />}
      {(errorPopupOpen.open && (errorPopupOpen.message === "Credits not found" || errorPopupOpen.message === "Insufficient credits")) && (
        <ErrorPopup
          open={errorPopupOpen.open}
          message={errorPopupOpen.message}
          onClose={() => setErrorPopupOpen({ open: false, message: "" })}
        />
      )}
      <Box>
        <Typography variant="h1" gutterBottom className="studioNavHeading">
          Generate cartoon ideas from real image
        </Typography>
      </Box>
      <Box
      className="cartoon-uploader"
      sx={{ display: "flex", gap: 4, padding: 4 }}
    >
      
      <Box sx={{ flex: "0 0 40%" }} className="leftUploader">
        <Box>

            <Box  sx={{ height: '175px' }}>
            <UploadImageCard
              image={draggedImage || (previews.length > 0 ? previews[0] : null)}
              onDelete={() => { setDraggedImage(null); setPreviews([]); setUploadFile(null); selectedImageId && setSelectedImageId(null); }}
              onUploadClick={handleButtonClick}
              onFileChange={handleUpload}
              fileInputRef={fileInputRef}
              setSelectedImageId={setSelectedImageId}
              selectedImageId={selectedImageId}
            />
          </Box>
           <Box className="upload-button-container">
          <ReusableButton disabled={ !draggedImage && previews.length === 0} onClick={generateFetchImages}>
            Generate (100 Credits)
          </ReusableButton>
        </Box>
        </Box>

       

        {uploadExistingImages.length > 0 ? (
          <Box mb={4} className="upload-image-container">
            <Box className="position-sticky" sx={{ display: 'flex', gap: 2,  justifyContent: 'space-between',paddingRight:2, alignItems: 'center'}}>
         <Typography variant="h6" gutterBottom className="subTitle">
          Uploaded Images
        </Typography>
        <Box sx={{ display: 'flex', gap: 1, mb: 2 }}>
            {uploadedViewType === "masonry" ?
            <ViewModuleIcon className="iconColor"  onClick={() => setUploadedViewType('grid')}/> :(
            <ViewQuiltIcon className="iconColor" onClick={() => setUploadedViewType('masonry')}/>

            )}
        </Box>
       </Box>
            <Grid className="cartoonImages">
            {uploadedViewType === 'grid' ? (
              <Grid container spacing={1}>
                {uploadExistingImages.map((data: any, index: any) => (
                  <Grid item xs={12} sm={6} md={3} lg={3} key={index}>
                    <Card sx={{ width: "100%" }} className="existing-card">
                      <CardMedia
                        component="img"
                        image={data.url}
                        alt={`Preview ${index}`}
                        width="100%"
                        height={200}
                        className="existring-image-card"
                        draggable={true}
                        onDragStart={() => handleDragStart(data?.url)}
                      />
                    </Card>
                  </Grid>
                ))}
              </Grid>
            ) : (
              <Masonry
                breakpointCols={{ default: 4, 1100: 3, 700: 2, 500: 1 }}
                className="my-masonry-grids"
                columnClassName="my-masonry-grid_column"
                style={{ width: '100%' }}
              >
                {uploadExistingImages.map((data: any, index: any) => (
                  <Card sx={{ width: "100%" }} className="existing-card" key={index}>
                    <CardMedia
                      component="img"
                      image={data.url}
                      alt={`Preview ${index}`}
                      width="100%"
                      className="existring-image-card"
                      draggable={true}
                      onDragStart={() => handleDragStart(data?.url)}
                    />
                  </Card>
                ))}
              </Masonry>
            )}
            </Grid>
          </Box>
        ) : (
          <Typography variant="body1">No images uploaded yet.</Typography>
        )}
      </Box>

      {/* Right Section - 50% */}
      <Box sx={{ flex: "0 0 60%" , overflowY: 'auto' , height: 'calc(100vh - 200px)'}}>
       <Box className="backgroundColor-2D3157 position-sticky" sx={{ display: 'flex', gap: 2,  justifyContent: 'space-between',paddingRight:2, alignItems: 'center' ,backgroundColor: "#2D3157"}}>
         <Typography variant="h6" gutterBottom className="subTitle">
          Generated Images
        </Typography>
        <Box sx={{ display: 'flex', gap: 1, mb: 2 }}>

            {viewType === "masonry" ?
            <ViewModuleIcon className="iconColor"  onClick={() => setViewType('grid')}/> :(
            <ViewQuiltIcon className="iconColor" onClick={() => setViewType('masonry')}/>

            )}
        </Box>
       </Box>
       <Box className="generated-Imagess">
        {viewType === 'grid' ? (
          <Grid container spacing={1}>
            {generateImage.length > 0 ? (
              generateImage.map((item: any, index: number) => {
                const imageUrl = item?.url;
                return (
                  <Grid item xs={6} sm={6} md={3} lg={3} key={item._id || index}>
                    <Card
                      onMouseEnter={() => handleMouseEnter(index)}
                      onMouseLeave={handleMouseLeave}
                      className="generate-card"
                    >
                      <CardMedia
                        component="img"
                        image={imageUrl || cartoonImageUrl}
                        alt={`Generated Image ${index}`}
                        className={`${item.isGenerated ? "generate-Image-card" : "generate-blur-card"}`}
                      />
                      {hoveredCard === index && item.isGenerated && (
                        <Box className="hoverbtn-cartoon">
                          <Button
                            className="previewButton"
                            onClick={() => handleClickOpen(item)}
                            sx={{ color: "#fff" }}
                          >
                            <VisibilityIcon className="iconColor" />
                            <Typography className="previewText">Preview</Typography>
                          </Button>
                        </Box>
                      )}
                    </Card>
                  </Grid>
                );
              })
            ) : (
              <Grid container item xs={12} spacing={10}>
                <Typography variant="body1" className="no-image-text">
                  No images generated yet.
                </Typography>
              </Grid>
            )}
          </Grid>
        ) : (
          <Masonry
            breakpointCols={{ default: 4, 1100: 3, 700: 2, 500: 2 }}
            className="my-masonry-grids"
            columnClassName="my-masonry-grid_column"
          >
            {generateImage.length > 0 ? (
              generateImage.map((item: any, index: number) => {
                const imageUrl = item?.url;
                return (
                  <Card
                    key={item._id || index}
                    onMouseEnter={() => handleMouseEnter(index)}
                    onMouseLeave={handleMouseLeave}
                    className="generate-card"
                    style={{ marginBottom: 16 }}
                  >
                    <CardMedia
                      component="img"
                      image={imageUrl || cartoonImageUrl}
                      alt={`Generated Image ${index}`}
                      className={`${item.isGenerated ? "generate-Image-cards" : "generate-blur-card"}`}
                    />
                    {hoveredCard === index && item.isGenerated && (
                      <Box className="hoverbtn-cartoon">
                        <Button
                          className="previewButton"
                          onClick={() => handleClickOpen(item)}
                          sx={{ color: "#fff" }}
                        >
                          <VisibilityIcon className="iconColor" />
                          <Typography className="previewText">Preview</Typography>
                        </Button>
                      </Box>
                    )}
                  </Card>
                );
              })
            ) : (
              <Typography variant="body1" className="no-image-text">
                No images generated yet.
              </Typography>
            )}
          </Masonry>
        )}
        </Box>

        {/* modelOpen */}
          {modelOpen && (
            <Popup
              open={modelOpen}
              onClose={handleClose}
              mainVideo={previewImage?.cartoonImage}
              leftColumnType="image"
              leftImageSrc={previewImage?.inputImage}
              rightColumnType="image"
              previewImageSrc={previewImage?.cartoonImage}
              leftPromptText={previewImage?.inputImage}


            />
          )}
      </Box>
    </Box>
    </Box>
  );
};

export default CartoonUploader;
